
 <ag-grid-angular #agGrid 
 #agGrid_alerta  domLayout='autoHeight' class="ag-theme-alpine"  [columnDefs]="columnDefs"
 [defaultColDef]="defaultColDef" [rowData]="rowData"
 [sideBar]="false"  (gridReady)="onGridReady($event)"
 domLayout='autoHeight'
 [pagination]="true"
 [paginationPageSize]="100">
 </ag-grid-angular>